import { useState } from "react";

const useFirebase = () => {
  // side bar states in header
  const [sideBar, setSideBar] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setToast(false);
    setShow(true);
  };
  const viewCartFromSideBar = (navigate) => {
    selectCart();
    navigate("/profile");
  };

  // toast and opening cart item states in Product details
  const [showToast, setToast] = useState(false);
  const closeToast = () => setToast(false);
  const addToCart = () => setToast(true);

  // profile tabs states in profile page
  const [overview, setOverview] = useState(true);
  const [cart, setCart] = useState(false);
  const [order, setOrder] = useState(false);
  const [wish, setWish] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const hideInfoModal = () => setShowInfo(false);
  const showInfoModal = () => setShowInfo(true);
  // showInfo,wish,order,cart,overview
  const selectOverview = () => {
    setOverview(true);
    setCart(false);
    setOrder(false);
    setWish(false);
  };
  const selectCart = () => {
    setOverview(false);
    setCart(true);
    setOrder(false);
    setWish(false);
  };
  const selectWish = () => {
    setOverview(false);
    setCart(false);
    setOrder(false);
    setWish(true);
  };
  const selectOrder = () => {
    setOverview(false);
    setCart(false);
    setOrder(true);
    setWish(false);
  };

  
  return {
    // side bar states in header
    handleShow,
    handleClose,
    sideBar,
    setSideBar,
    show,
    viewCartFromSideBar,
    // toast and opening cart item states in Product details
    showToast,
    closeToast,
    addToCart,
    // profile tabs states in profile page
    selectOverview,
    selectCart,
    selectWish,
    selectOrder,
    hideInfoModal,
    showInfoModal,
    showInfo,
    wish,
    order,
    cart,
    overview
  };
};

export default useFirebase;
